import { faDownload, faStar as faStarSolid, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular, faEye as faEyeRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GetProposalPdf, ProposalListView, SetProposalPdfFavorite } from '../../../API/Proposal';


export default ({ showButton, reloadParent, ...props }) => {
    const [proposals, setProposals] = useState([]);
    const [allowDownload, setAllowDownload] = useState(false);
    const [hideProposals, setHideProposals] = useState(false);

    useEffect(() => {
        LoadProposals(props.jobId)
    }, [props.jobId])

    const LoadProposals = (id) => {
        ProposalListView(id)
            .then(res => {
                setProposals(res.data.proposals)
                setAllowDownload(res.data.allowDownload)
            })
    }

    const FavoriteProposal = (proposal, idx) => {
        const updatedProposals = proposals.map((p, i) =>
            i === idx ? { ...p, favorite: !p.favorite } : { ...p, favorite: false }
        );
        SetProposalPdfFavorite(updatedProposals[idx]).then(res => {
            if (res.success) setProposals(updatedProposals);
        });
    };

    const showWindow = (id, name) => {
        GetProposalPdf(id)
            .then(res => {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    let displayName = name ? `${name}.pdf` : `Proposal-${id}.pdf`
                    window.navigator.msSaveOrOpenBlob(res, displayName);
                }
                else {
                    var objectUrl = URL.createObjectURL(res);
                    window.open(objectUrl);
                }
            })
    }

    const download = (id, name) => {
        let download = require('downloadjs')
        let displayName = name ? `${name}.pdf` : `Proposal-${id}.pdf`
        GetProposalPdf(id)
            .then(res => {
                download(res, displayName)
            })
    }
    const maxProposalId = Math.max(...proposals.map(p => p.proposalId));
    const hasFavorites = true;// proposals.some(p => p.favorite);
    return (
        <>
            <ListGroup id="proposal_list">
                <ListGroup.Item className="enc-list">
                    <div className="row align-items-center">
                        <FontAwesomeIcon icon={hideProposals === false ? faEye : faEyeSlash} className="clickable" onClick={() => setHideProposals(!hideProposals)} />
                        <div className="col">
                            Proposals
                        </div>
                    </div>
                </ListGroup.Item>
                {proposals.length === 0 && <ListGroup.Item>No Generated Proposals Found</ListGroup.Item>}
                {proposals.map((m, i) => {
                    const shouldShow =
                        !hideProposals ||
                        (!hasFavorites && m.proposalId === maxProposalId) ||
                        m.favorite;
                    return shouldShow ? (
                        <ListGroup.Item key={`proposalPdf-${i}`} className="enc-list">
                            <div className="row">
                                <div className={`lg-item-favorite lg-item-favorite-${Boolean((!hasFavorites && m.proposalId === maxProposalId) || m.favorite)}`}>
                                    <FontAwesomeIcon icon={
                                        (!hasFavorites && m.proposalId === maxProposalId) || m.favorite === true ? faStarSolid : faStarRegular
                                    }
                                    className="clickable" onClick={() => FavoriteProposal(m, i)} />
                                </div>
                                <div className="col">
                                    <strong> {m.proposalName ? m.proposalName : `Proposal ${m.proposalId}`}</strong>
                                </div>
                                {allowDownload && <div className="col text-right">
                                    <FontAwesomeIcon icon={faEyeRegular} className="clickable" onClick={() => showWindow(m.proposalId)} />
                                    <FontAwesomeIcon icon={faDownload} className="clickable ml-2" onClick={() => download(m.proposalId)} />
                                </div>}
                            </div>

                        </ListGroup.Item>
                    ) : null
                }
                )}

            </ListGroup>
            <div className="row mt-1">
                <div className="col text-right">
                    {showButton &&
                        <Button as={Link} to={`${props.url}/Proposal`} className="enc-button">
                            {proposals.length === 0 ? "Build" : "Edit"} Proposal</Button>
                    }
                </div>
            </div>
        </>
    )
}
